import { render, staticRenderFns } from "./PieCharts.vue?vue&type=template&id=6b2a7c14&scoped=true&"
import script from "./PieCharts.vue?vue&type=script&lang=js&"
export * from "./PieCharts.vue?vue&type=script&lang=js&"
import style0 from "./PieCharts.vue?vue&type=style&index=0&id=6b2a7c14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2a7c14",
  null
  
)

export default component.exports